import React from 'react'
import { Container } from './styled'
import Input from './Input'
import BooleanField from 'live/components/widget/config/forms/boolean-field'
import { PropsInput } from '../../Types'

interface Props {
    config: PropsInput
    onChange: Function
}
export default function CfgInput({ config, onChange }: Props): JSX.Element {
    return (
        <Container>
            <div className="gauge-input-item">
                <div className="gauge-input-item-two-columns">
                    <Input
                        config={config}
                        onChange={onChange}
                        className="input-title"
                        inputType="text"
                        inputName="title"
                        label="Title"
                    />
                    <Input
                        config={config}
                        onChange={onChange}
                        className="input-unit"
                        inputType="text"
                        inputName="unit"
                        label="Unit"
                    />
                </div>
            </div>
            <div className="gauge-input-item">
                <div className="gauge-input-item-two-columns">
                    <Input
                        config={config}
                        onChange={onChange}
                        className="input-value"
                        inputType="text"
                        inputName="value"
                        label="Value"
                    />
                    <Input
                        config={config}
                        onChange={onChange}
                        className="input-value-color"
                        inputType="text"
                        inputName="valueColor"
                        label="color"
                    />
                </div>
            </div>
            <div className="gauge-input-item">
                <div className="gauge-input-item-two-columns">
                    <Input
                        config={config}
                        onChange={onChange}
                        className="input-target"
                        inputType="text"
                        inputName="target"
                        label="Target"
                    />
                    <Input
                        config={config}
                        onChange={onChange}
                        className="input-target-color"
                        inputType="text"
                        inputName="targetColor"
                        label="color"
                    />
                </div>
            </div>

            <div className="gauge-input-item">
                <div className="config-form is-checkbox">
                    <span className="regular helper-tooltip-info">
                        Enable extreme unity <i className="fa fa-question-circle-o help-tip"></i>
                    </span>
                    <BooleanField
                        onChange={() => onChange('extremeUnity', !config.extremeUnity)}
                        active={config.extremeUnity}
                    />
                </div>
            </div>

            <div className="gauge-input-item">
                <div className="config-form is-checkbox">
                    <span className="regular helper-tooltip-info">
                        Range colors <i className="fa fa-question-circle-o help-tip"></i>
                    </span>
                    <BooleanField
                        onChange={() => onChange('usingRange', !config.usingRange)}
                        active={config.usingRange}
                    />
                </div>
            </div>
            {config.usingRange ? (
                <>
                    <div className="gauge-input-item">
                        <div className="config-form is-checkbox">
                            <input
                                checked={config.showDivider}
                                type="checkbox"
                                onChange={() => onChange('showDivider', !config.showDivider)}
                                style={{ marginRight: '4px' }}
                            />

                            <span className="regular helper-tooltip-divider">
                                Show divider <i className="fa fa-question-circle-o help-tip"></i>
                            </span>
                        </div>
                        <div className="config-form is-checkbox">
                            <input
                                checked={config.gradient}
                                type="checkbox"
                                onChange={() => onChange('gradient', !config.gradient)}
                                style={{ marginRight: '4px' }}
                            />

                            <span className="regular helper-tooltip-gradient">
                                Gradient color <i className="fa fa-question-circle-o help-tip"></i>
                            </span>
                        </div>
                    </div>

                    <div className="gauge-input-item">
                        {/* <div className="config-form is-checkbox">
                            <input
                                checked={config.combineColors}
                                type="checkbox"
                                onChange={() => onChange('combineColors', !config.combineColors)}
                                style={{ marginRight: '2px' }}
                            />
                            <span className="regular">Combine colors</span>
                        </div> */}
                        <div className="gauge-input-item-three-columns">
                            <Input
                                config={config}
                                onChange={onChange}
                                className="input-range-three-colors"
                                inputType="text"
                                inputName="stopsColor1"
                                label="Color #1"
                            />
                            <Input
                                config={config}
                                onChange={onChange}
                                className="input-range-three-colors"
                                inputType="text"
                                inputName="stopsColor2"
                                label="Color #2"
                            />
                            <Input
                                config={config}
                                onChange={onChange}
                                className="input-range-three-colors"
                                inputType="text"
                                inputName="stopsColor3"
                                label="Color #3"
                            />
                        </div>
                    </div>
                    <div className="gauge-input-item">
                        <div className="gauge-input-item-three-columns">
                            <Input
                                config={config}
                                onChange={onChange}
                                className="input-range-three-colors"
                                inputType="number"
                                min="0"
                                max="100"
                                inputName="stopsValue1"
                                label="Value #1"
                            />
                            <Input
                                config={config}
                                onChange={onChange}
                                className="input-range-three-colors"
                                inputType="number"
                                min="0"
                                max="100"
                                inputName="stopsValue2"
                                label="Value #2"
                            />
                            <Input
                                config={config}
                                onChange={onChange}
                                className="input-range-three-colors"
                                inputType="number"
                                min="0"
                                max="100"
                                inputName="stopsValue3"
                                label="Value #3"
                            />
                        </div>
                    </div>
                </>
            ) : null}
        </Container>
    )
}
